function isPhoneValid (value) {
    const sanitizedPhone = value.replace(/\D/g, '')
    return sanitizedPhone.length >= 10
}

export default {
    isPhoneValid
}
